import { database, authentication, fbDbRefs } from "../app-database";

const refNotificacionesListado = database.ref("notificaciones/mensajes");

export const getListadoNotificaciones = () => {
	return new Promise(function (resolve, reject) {
		refNotificacionesListado.once("value", snapshot => {
			let msnListado = snapshot.val() ? snapshot.val() : [] ;
			resolve(msnListado);
		});
	});
};

export const notificacionSetInicial = () => {
	return new Promise((resolve) => {
		let refUsuario = database.ref("notificaciones/usuarios/" + authentication.currentUser.uid);
		refUsuario.once("value").then(oValue => {
			let data = oValue.val();
		
			getListadoNotificaciones().then((lista) => {
				let insert = { timestamp: new Date().getTime() };
				
				if(data == null) {
					Object.keys(lista).map((item) => { 
						insert[item] = { leido: false, eliminado: false };
					});
				} else {
					Object.keys(lista).map((item) => { 
						if(data[item]) {
							let leido = (data[item].leido)? data[item].leido : false;
							let eliminado = (data[item].eliminado)? data[item].eliminado : false;
							
							insert[item] = { "leido": leido, "eliminado": eliminado };
						} else {
							insert[item] = { leido: false, eliminado: false };
						}
					});
				}
				
				refUsuario.set(insert, (onComplete) => {
					resolve(true);
				});
			});
		});
	});
};

export const notificacionCarga = (sParam) => {
	let refUsuario = database.ref("notificaciones/usuarios/" + authentication.currentUser.uid);
	fbDbRefs.push(refUsuario);
	
	return dispatch => {
		refUsuario.on("value", snapshot => {
			getListadoNotificaciones().then((lista) => {
				let data = snapshot.val();
				let bullet = 0;
				let msnLista = [];
				
				if(data != null) {
					delete data.timestamp;
					Object.keys(data).map((item) => { 
						if(lista[item]) {
							let msn = lista[item];
							msn.id = item;
							msn.leido = (data[item].leido)? data[item].leido : false;
							msn.eliminado = (data[item].eliminado)? data[item].eliminado:  false;
							
							if(msn.eliminado == false) {
								msnLista.push(msn);
							}
							
							if(!msn.leido) {
								bullet++;
							}
						}
					});
				}
				dispatch({ "type": "NOTIFICACIONES_LLENAR", "listado": msnLista, "bullet": bullet });
			});
		});
	};
};

export const notificacionActualiza = (sParam) => {
	database.ref("notificaciones/usuarios/" + authentication.currentUser.uid + "/" + sParam.nid).update({"leido":true});
};

export const notificacionElimina = (sParam) => {
	database.ref("notificaciones/usuarios/" + authentication.currentUser.uid + "/" + sParam.nid).update({"eliminado":true});
};

authentication.onAuthStateChanged((user) => {
	if (user && authentication.currentUser && !authentication.currentUser.isAnonymous) {
		refNotificacionesListado.on("child_changed", function(data) {
			notificacionSetInicial();
		});
		refNotificacionesListado.on("child_removed", function(data) {
			notificacionSetInicial();
		});
	} else {
		refNotificacionesListado.off();
	}
});


// WEBPACK FOOTER //
// ./src/notificaciones/notificaciones.act.js